import React, { useState, useEffect } from "react";
import {
    Form,
    Input,
    Button,
    Row,
    Col,
    notification, Select, Table, Radio, Tooltip, Tag
} from "antd";
import { InfoCircleOutlined, PlusOutlined } from '@ant-design/icons';
import { 
    deleteTemplateDeviceMode, putTemplateDeviceMode, getTemplateDeviceMode, getTemplateLockOptions 
} from "../../../axios/api.device"

import { useTranslation } from "react-i18next";
import i18n from "@src/locales";
import TextArea from "antd/lib/input/TextArea";

const { Column } = Table;
const { Item } = Form;
interface propsModel {
    templateId: string,
    platform: string,
    templateTab: any,
    updateTemplate: () => void,
}

export const TemplateDeviceMode = (props: propsModel) => {
    const { templateId, platform, templateTab, updateTemplate } = props;
    const [showTable, setShowTable] = useState<number>(0);
    const [dataForm] = Form.useForm();
    const [selectModeType, setSelectModeType] = useState<string>("LostMode");

    const { t } = useTranslation();

    var addClick = () => {
        setShowTable(2);
        dataForm?.resetFields();
    }

    useEffect(() => {
        getDataInfo();
    }, [])

    const getDataInfo = () => {
        getTemplateDeviceMode(templateId).then((res) => {
            console.log(res);
            if (res && res != null) {
                setShowTable(2)
                var data: any = {};
                dataForm?.setFieldsValue(res);
            } else {
                setShowTable(1)
            }
        });
    }
    const addTemplateClick = () => {
        dataForm?.validateFields().then(
            (res) => {
                putTemplateDeviceMode(templateId, res).then(() => {
                    updateTemplate();
                    notification.success({ message: t("成功") });
                    dataForm.resetFields();
                    getDataInfo();
                })
            })
    }
    const deleteTemplateClick = () => {
        deleteTemplateDeviceMode(templateId).then(() => {
            updateTemplate();
            notification.success({ message: t("成功") });
            dataForm?.resetFields();
            getDataInfo();
        })
    }
    // const onLoadImage = () => {
    //     drawImage(null);
    // }
    return (<>
        <div>
            <Row style={{ margin: "32px 16px 8px 50px", fontSize: "16px" }}>
                <Col className="templateTitle">{t("设备模式")}</Col>
                {platform != "Android" && (
                    <Col style={{ marginLeft: 36 }}>
                        {templateTab?.availabilities?.map((c: any) => (
                            <Tooltip title={
                                i18n.language === "zh" ? `只能在${c}以上的设备上才能配置` : 
                                i18n.language === "en" ? `Only be configured on devices above iOS ${c}` : ""
                            }>
                                <Tag color="cyan">{c}</Tag>
                            </Tooltip >
                        ))}
                        {templateTab?.supervisedRequired && (
                            <Tooltip title={t("只适用于受监督设备")}>
                                <Tag color="purple">S</Tag>
                            </Tooltip>
                        )}
                    </Col>
                )}
            </Row>
            <Row><div className="dividerStyle"></div></Row>
            <Row style={{ margin: "16px 16px 16px 0px" }}>
                {showTable == 1 && (
                    <div>
                        <p style={{ margin: "32px 16px 8px 50px", fontSize: "14px" }}>
                            {t("设置设备模式")}</p>
                        <div style={{ margin: "32px 16px 8px 50px", fontSize: "16px" }}>
                            <Button onClick={() => { addClick(); }} type="primary">
                                <PlusOutlined /> {t("添加规则")}
                            </Button>
                        </div>
                    </div>
                )}
                {showTable == 2 && (
                    <>
                        <Form
                            style={{ width: "90%", marginTop: 36 }}
                            layout="horizontal"
                            form={dataForm}
                            labelCol={{ span: 4 }}
                            initialValues={{ modeType: "LostMode" }}
                        >
                            <Item label={t("设备模式")} name="modeType" rules={[{ required: true }]}  extra={
                                    <div style={{display: "flex", alignItems: "center"}}>
                                        <InfoCircleOutlined />&nbsp;&nbsp;
                                        <span>{t("设置设备开启丢失模式")}</span>
                                    </div>
                                }>
                                <Select>
                                <Select.Option value="LostMode">{t("丢失模式")}</Select.Option>
                                </Select>
                            </Item>
                            {selectModeType === "LostMode" && <>
                                <Item label={t("手机号码")}  name="phoneNumber" extra={
                                    <div style={{display: "flex", alignItems: "center"}}>
                                        <InfoCircleOutlined />&nbsp;&nbsp;
                                        <span>{t("文案支持参数，如设备组名称$(deviceGroupName), 设备备注$(remark), 设备备注二$(remark2), 用户备注$(userRemark)")}</span>
                                    </div>
                                }>
                                    <Input autoComplete="off" />
                                </Item>
                                <Item label={t("消息")} name="content" rules={[{required: true}]} extra={
                                    <div style={{display: "flex", alignItems: "center"}}>
                                        <InfoCircleOutlined />&nbsp;&nbsp;
                                        <span>{t("此信息将展示在锁屏界面底部，文案支持参数，如序列号$(sn), 设备名称$(name), 设备组名称$(deviceGroupName), UDID $(UDID), 设备备注$(remark), 设备备注二$(remark2), 用户名称$(userName), 用户备注$(userRemark)")}</span>
                                    </div>
                                }>
                                    <TextArea rows={4} />
                                </Item>
                            </>}
                        </Form>
                        <div style={{ margin: "32px 16px 8px 50px", fontSize: "20px", textAlign: "center", width: "100%" }}>
                            <Button style={{ width: 100 }} type="primary" onClick={() => { addTemplateClick(); }}> {t("保存")} </Button>
                            <Button style={{ width: 100, marginLeft: 20 }} type="primary" ghost onClick={() => { deleteTemplateClick(); }}>{t("删除规则")}</Button>
                        </div>
                    </>
                )}
            </Row>
        </div>

    </>)
};